// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2LA4n","rootSuccess":"CompleteLink_rootSuccess__3o0VE","rootFailure":"CompleteLink_rootFailure__ebREi","isDisabled":"CompleteLink_isDisabled__2u3cd"};